import { IncomingMessage } from 'http';

import type { AppContext, AppInitialProps } from 'next/app';
import { v4 as uuidv4 } from 'uuid';

import { callService } from '@api/caller';
import { getCookies, setCookies } from '@libs/cookies-next/src';

import { decodeToken } from './jwt';

const requestIsFromCurrentDomain = (req: IncomingMessage) => {
  const { host, referer } = req.headers;
  return host === referer?.split('/')[2];
};

export const withSession =
  (getInitialProps: (ctx: AppContext) => Promise<AppInitialProps>) =>
  (appContext: AppContext) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const ctx: any = appContext.ctx;
    const { req, res } = appContext.ctx;
    const cookies = getCookies({ req, res });
    const { sessionId } = cookies;
    if (shouldSetSessionId(sessionId, req?.method)) {
      setCookies('sessionId', uuidv4(), {
        req,
        res,
        httpOnly: true,
        maxAge: 60 * 60 * 24,
        secure: process.env.NODE_ENV === 'production',
      });
    }
    if ((req && requestIsFromCurrentDomain(req)) || sessionId) {
      const { token, userId } = cookies;
      if (token && userId) {
        ctx.loginInfo = { token, userId };
      }
    }
    return getInitialProps(appContext);
  };

const shouldSetSessionId = (sessionId: string, httpMethod?: string) =>
  !sessionId && /get/gi.test(httpMethod ?? '');

export const querySessionsVars = async (hashTokenKey = '') => {
  if (!hashTokenKey) return {};
  try {
    // get the token from the redis server
    const { value: paymentRequestToken } = await callService(
      'CachesService',
      'getPaymentKey',
      {
        key: hashTokenKey,
      }
    );
    return decodeToken(paymentRequestToken) ?? {};
  } catch (e) {
    return {};
  }
};
